/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */

import apiFetcher from './apiFetcher'
import Constants from '../Constants'
import BlogCategory from '../types/entities/BlogCategory';
import BlogArticle from '../types/entities/BlogArticle';
import GetBlogArticlesResponse from '../types/responses/GetBlogArticles';

const API = {
    getBlogArticles: async (
        page: number,
        category: BlogCategory|null = null,
        perPage: number = 25,
        skipArticle: BlogArticle | null = null
    ): Promise<GetBlogArticlesResponse> => {
        const getParams = new URLSearchParams();
        if (typeof category !== 'undefined' && category && category.slug) {
            getParams.set('category', category.slug);
        }
        if (typeof skipArticle !== 'undefined' && skipArticle && skipArticle.slug) {
            getParams.set('skipArticle', skipArticle.slug);
        }
        getParams.set('page', String(page));
        getParams.set('perPage', String(perPage));

        const result = await apiFetcher('/blog-posts/?' + getParams.toString(), {})
            .then(r => r.json())
            .catch(e => {
                Constants.logException(e)
                return false
            })

        if (!result || !result.success || !result.data || !result.data.blogArticles) {
            if (result && result.error) {
                throw result.error
            }
            throw 'Die Magazin Artikel konnten nicht geladen werden'
        }

        return result
    },
    loadBlogArticle: async (slug: string): Promise<BlogArticle | null> => {
        const result = await apiFetcher('/blog-posts/' + slug)
            .then(async r => await r.json())
            .catch(e => {
                Constants.logException(e)
                return false
            })
        if (result && result.data) {
            return result.data.blogArticle ?? null
        } else {
            let errorMessage = ''
            if (result && result.error) {
                errorMessage = result.error
            } else {
                errorMessage = 'Der Magazin Artikel konnte nicht geladen werden'
            }
            Constants.logMessage('Error in load blog article api call: ' + errorMessage)
            throw errorMessage
        }
    },
    getBlogCategories: async (): Promise<BlogCategory[]> => {
        const result = await apiFetcher('/blog-categories', {})
            .then(r => r.json())
            .catch(e => {
                Constants.logException(e)
                return false
            })

        if (!result || !result.success || !result.data || !result.data.blogCategories) {
            return []
        }

        return result.data.blogCategories
    },
    sendContactForm: async (formData: object): Promise<boolean> => {
        const result = await apiFetcher('/contact', {
            method: 'post',
            body: JSON.stringify(formData),
        })
            .then(r => r.json())
            .catch(e => {
                Constants.logException(e)
                return false
            })
        return result && result.success
    },
}

export default API
